<template>
  <div class="Parent">
    <div class="content">
      <div class="map" id="allmap"
           :style="{'height': `calc(100vh - ${octopus.passport.bangs ? '64px' : '50px'} - 90px)`}">&nbsp;
      </div>
    </div>
    <div class="footPanel" v-if="octopus.passport.campus">
      <van-action-sheet v-model="minPanel" duration="0.2" class="minPanel" :overlay="false" round="true"
                        :class="octopus.passport.bangs ? 'minBangs' : ''">
        <div class="arrow" @click="showStudentInfoPanel(1)">
          <div class="icon iconjiantouxiangshang-01 a1"></div>
          <div class="icon iconjiantouxiangshang-01 a2"></div>
        </div>
        <div class="personal">
          <div class="photo"
               v-bind:style="{backgroundImage: 'url('+ octopus.passport.campus.parent.studentPhoto +')'}"></div>
          <div class="body">
            <span class="name">{{octopus.passport.campus.parent.studentName}}</span>
            <span class="class">{{octopus.passport.campus.parent.className}}</span>
          </div>
          <div class="icon iconweb-icon-" v-on:click="chooseStudent"></div>
        </div>
        <div class="sensor">
          <div class="code">设备号：{{studentInfo.SensorCode}}</div>
          <div class="electric">
            <span v-bind:class="'icon '+ studentInfo.PowerIcon"></span>
            <span class="text"><span>{{studentInfo.Electricity}}%</span></span>
          </div>
        </div>
      </van-action-sheet>
      <van-action-sheet v-model="fullPanel" duration="0.4" class="maxPanel" :overlay="false" round="true"
                        :class="octopus.passport.bangs ? 'maxBangs' : ''">
        <div class="arrow" @click="showStudentInfoPanel(0)">
          <div class="icon iconjiantouxiangshang-01 a1 reversal"></div>
          <div class="icon iconjiantouxiangshang-01 a2 reversal"></div>
        </div>
        <div class="personal">
          <div class="photo"
               v-bind:style="{backgroundImage: 'url('+ octopus.passport.campus.parent.studentPhoto +')'}"></div>
          <div class="body">
            <span class="name">{{octopus.passport.campus.parent.studentName}}</span>
            <span class="class">{{octopus.passport.campus.parent.className}}</span>
          </div>
          <div class="icon iconweb-icon-" v-on:click="chooseStudent"></div>
        </div>
        <div class="sensor">
          <div class="code">设备号：{{studentInfo.SensorCode}}</div>
          <div class="electric">
            <span v-bind:class="'icon '+ studentInfo.PowerIcon"></span>
            <span class="text"><span>{{studentInfo.Electricity}}%</span></span>
          </div>
        </div>
        <div class="asymptomatic">
          <div class="item">
            <div class="icon iconjiankangzhongxin-20 yellow"></div>
            <div class="text">步数：</div>
            <div class="value">{{studentInfo.Steps}}步</div>
          </div>
          <div class="item">
            <div class="icon iconxinlv-01 red"></div>
            <div class="text">心率：</div>
            <div class="value">{{studentInfo.HeartRate}}次/分钟</div>
          </div>
          <div class="item">
            <div class="icon iconxueya red"></div>
            <div class="text">血压：</div>
            <div class="value">{{studentInfo.Systolic}}/{{studentInfo.Diastolic}}mmHg</div>
          </div>
          <div class="item">
            <div class="icon icontiwen-01 yellow"></div>
            <div class="text">体温：</div>
            <div class="value">{{studentInfo.Temp}}℃</div>
          </div>
          <div class="item">
            <div class="icon iconshuimian-01 blue"></div>
            <div class="text">睡眠质量：</div>
            <div class="value">{{studentInfo.SleepStatus}}</div>
          </div>
          <div class="item" v-if="studentInfo.IsOpenOxygen">
            <div class="icon iconziyuan2 red"></div>
            <div class="text">血氧：</div>
            <div class="value">{{studentInfo.Oxygen}}%</div>
          </div>
        </div>
      </van-action-sheet>
    </div>
    <van-popup v-model="showChooseStudent" class="choosePanel" round="true">
      <div class="title">
        <!--        <div class="time">2021-10-23</div>-->
        <div class="name">切换孩子</div>
      </div>
      <div class="list">
        <van-radio-group v-model="studentCheckID" v-on:change="setStudent">
          <van-cell v-for="(item, index) in studentListData" :key="item.ID">
            <van-radio :name="item.ID">{{item.Name}} - {{item.ClassName}}</van-radio>
          </van-cell>
        </van-radio-group>
      </div>
    </van-popup>
  </div>
</template>

<script>
  export default {
    name: "app_en_database_item", /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */
    data() {
      return {
        octopus: this.$parent.octopus,
        // 迷你面板
        minPanel: true,
        // 完整面板
        fullPanel: false,
        // 学生 体能 和 定位 数据
        studentInfo: {},
        // 显示选择孩子面板
        showChooseStudent: false,
        // 选择孩子数据源
        studentListData: {},
        // 选中孩子的值
        studentCheckID: 0,
      }
    },
    created: function () {
      // 先加载学生信息。
      this.load();
    },
    activated: function () {
      // 先加载学生信息。
      this.load();
    },
    methods: {
      load: function () {
        this.loadStudent();
      },
      // 加载学生数据
      loadStudent: function () {
        let o = this;
        // 查询数据绑定关系，返回的必定是带传感器的学生信息。
        this.octopus.request.api.post("/Octopus/Engine/List", {
            id: 241,
            // value: this.octopus.passport.project,
            pageData: {rowSize: 77},// 一个爸妈最多 7 个孩子。
            cellData: [
              {name: "ID",},            // 学生ID
              {name: "Code"},           // 学号
              {name: "Name"},           // 学生名
              {name: "Sex"},            // 性别
              {name: "PhotoData"},      // 头像
              {name: "ClassIDValue"},        // 所属班级ID
              {name: "ClassName"},      // 所属班级
              {name: "ClassLevelIDValue"},   // 班级年级
              {name: "SchoolIDValue"},       // 校区ID
              {name: "SchoolName"},     // 校区名
              {name: "SensorIDValue", filterKey: ">", filterValue: 0}, // 传感器 必须要有绑定值
              {name: "ParentID", filterKey: "=", filterValue: this.octopus.passport.id}, // 关联家长
            ],
          },
          (data) => {
            if (data.status.code === 200) {
              if (data.content.queryData.length > 0) {
                o.studentListData = data.content.queryData;

                // 得到学生信息
                let studentData = null;

                // 循环学生信息。
                $(o.studentListData).each(function (index, item) {
                  // 判断是否存在
                  if (o.octopus.passport.campus && o.octopus.passport.campus.parent && o.octopus.passport.campus.parent.studentID) {
                    if (item.ID == o.octopus.passport.campus.parent.studentID) {
                      studentData = item;
                    }
                  }
                });

                // 如果没有学生数据，则默认采用第一个。
                if (!studentData) {
                  // 得到学生信息
                  studentData = data.content.queryData[0];
                }

                // 设置默认为第一个孩子。
                o.studentCheckID = studentData.ID;

                // 改造passport使其具备学生相关数据
                let campus = {
                  parent: {
                    studentID: studentData.ID,
                    studentName: studentData.Name,
                    studentPhoto: JSON.parse(studentData.PhotoData)[0].url,
                    sex: studentData.Sex,
                    classID: studentData.ClassIDValue,
                    className: studentData.ClassName,
                    classLevelID: studentData.ClassLevelIDValue,
                    schoolID: studentData.SchoolIDValue,
                    schoolName: studentData.SchoolName,
                    sensorID: studentData.SensorIDValue,
                  },
                };
                o.$set(o.octopus.passport, 'campus', campus);

                // 执行后续加载事件。
                o.loadData();
              } else {
                // 如果没有孩子的信息，则默认置空。
                o.octopus.passport.campus = {};
                // 跳转家长 及 孩子 信息补充注册流程
                o.octopus.router.jump("/APP/Campus/User/Personal/Page?reg=1");
              }
            } else {
              o.octopus.tips.error(data);
            }
          }
        );
      },
      loadData: function () {
        // 加载家长数据
        this.loadStudentInfo();
      },
      // 加载学生数据
      loadStudentInfo: function () {
        let o = this;

        // 加载学生设备数据
        this.octopus.request.api.post("/Octopus/Engine/List", {
            id: 114,
            // value: this.octopus.passport.project,
            pageData: {rowSize: 1},// 取当前老师绑定的设备。
            cellData: [
              {name: "SensorID", filterKey: "=", filterValue: this.octopus.passport.campus.parent.sensorID}, // 传感器 必须要有绑定值
              {name: "SensorCode"}, // 关联教师
              {name: "HealthQuality"},
              {name: "HeartRate"},      // 心率
              {name: "Systolic"},       // 收缩压
              {name: "Diastolic"},      // 舒张压
              {name: "Pressure"},       // 压力
              {name: "SleepScore"},     // 睡眠分
              {name: "SleepStatus"},    // 睡眠状态
              {name: "Steps"},          // 步数
              {name: "Temp"},           // 体温
              {name: "WearRate"},       // 佩戴率
              {name: "Longitude"},      // 经度
              {name: "Latitude"},       // 纬度
              {name: "Oxygen"},         // 血氧
              {name: "Electricity"},    // 电量
              {name: "IsOpenOxygen"},   // 是否有血氧
              {name: "LocationTime"},   // 本地时间
            ],
            // 前台传入八爪鱼指定参数，八爪鱼会自动解析并动态替换，八爪鱼数据源中用 {#date} 表达 。
            paramData: {
              date: this.octopus.tools.date("yyyyMMdd"),   // 定义date日期
              year: this.octopus.tools.date("yyyy")
            }
          },
          (data) => {
            if (data.status.code === 200) {
              // console.log("))))" + JSON.stringify(data.content.queryData));
              if (data.content.queryData.length == 1) {

                // 绑定体能数据
                o.studentInfo = data.content.queryData[0];

                // 获取电量
                o.studentInfo.PowerIcon = "";
                if (o.studentInfo.Electricity <= 25) {
                  o.studentInfo.PowerIcon = "icondianliang1";
                } else if (o.studentInfo.Electricity <= 50) {
                  o.studentInfo.PowerIcon = "icondianliang2";
                } else if (o.studentInfo.Electricity <= 75) {
                  o.studentInfo.PowerIcon = "icondianliang3";
                } else {
                  o.studentInfo.PowerIcon = "icondianliang4";
                }

                o.studentInfo.Longitude = o.studentInfo.Longitude || 103.745667;// 经纬度，默认曲靖一中。
                o.studentInfo.Latitude = o.studentInfo.Latitude || 25.50573;
                o.studentInfo.LocationTime = o.studentInfo.LocationTime || '2021-10-01';

                // 加载地图
                o.loadMap();
              } else {
                o.octopus.tips.error("设备未找到，请联系管理员。");
              }
            } else {
              o.octopus.tips.error(data);
            }
          }
        );
      },
      loadMap: function () {
        let o = this;
        // 地图标题
        let mapTitle = this.octopus.passport.campus.parent.studentName
          + "<span class='smalText'>" + this.octopus.passport.campus.parent.schoolName + " - "  + this.octopus.passport.campus.parent.className + "</span>";
        // 加载百度地图引擎
        this.octopus.load.loadBaiduMap()
          .then((Baidu) => {
            let Map = new Baidu.Map('allmap', {enableMapClick: false});
            // 开启缩放
            let top_right_navigation = new Baidu.NavigationControl({
              anchor: BMAP_ANCHOR_TOP_RIGHT,
              type: BMAP_NAVIGATION_CONTROL_SMALL,
              top: 100
            });
            Map.addControl(top_right_navigation);
            Map.enableScrollWheelZoom(true);
            Map.centerAndZoom(new Baidu.Point(o.studentInfo.Longitude, o.studentInfo.Latitude), 18); // 地图级别



            let point = new Baidu.Point(o.studentInfo.Longitude, o.studentInfo.Latitude);
            let img = o.octopus.passport.campus.parent.sex == "男" ? 'boy' : 'girl';
            let myicon = new Baidu.Icon(require("../../../../../static/skin/default/APP/Campus/Location/TeacherLocation/img/n-" + img + ".png"), new Baidu.Size(50, 50), {
              imageSize: new Baidu.Size(50, 50), // 指定定位位置
              imageOffset: new Baidu.Size(0, 0), // 设置图片偏移
              anchor: new Baidu.Size(25, 15), // 设置图片偏移
            });
            let marker = new Baidu.Marker(point, {icon: myicon});
            Map.addOverlay(marker);
            let geoc = new Baidu.Geocoder();
            geoc.getLocation(point, (rs) => {
              // alert(JSON.stringify(rs));
              let address = rs.address;
              let opts = {
                width: 280,       // 宽度
                //height: 80,       // 高度
                title: mapTitle,
              };
              let color = '#0EB84B';
              let msg = `<div>体温: <span style="color: ${color}">${o.studentInfo.Temp} ℃</span></div><div>地址：${address}</div><div>上报时间：${o.studentInfo.LocationTime}</div>`
              let infoWindow = new Baidu.InfoWindow(msg, opts);  // 创建信息窗口对象
              Map.openInfoWindow(infoWindow, point);        // 打开信息窗口
            });
            marker.addEventListener("click", (event, aaa) => {
              let e = window.event || event;
              e.stopPropagation();
              geoc.getLocation(point, (rs) => {
                let address = rs.address;
                let opts = {
                  width: 280,     // 信息窗口宽度
                  //height: 80,    // 信息窗口高度
                  // title: "<span style='background-image:url("+ o.studentInfo.photo +");background-size: cover;width:30px;'>&nbsp;</span>" + o.studentInfo.name  // 信息窗口标题
                  title: mapTitle,
                }
                let color = '#0EB84B'
                let msg = `<div>体温: <span style="color: ${color}">${o.studentInfo.Temp} ℃</span></div><div>地址：${address}</div><div>上报时间：${o.studentInfo.LocationTime}</div>`
                let infoWindow = new Baidu.InfoWindow(msg, opts);  // 创建信息窗口对象
                Map.openInfoWindow(infoWindow, point);        // 打开信息窗口
              });
            });
            this.$emit("callHomeComplete", "send father data...")
            let top_left_scale = new Baidu.ScaleControl({
              anchor: BMAP_ANCHOR_TOP_RIGHT,
              type: BMAP_NAVIGATION_CONTROL_SMALL,
            });
            Map.addControl(top_left_scale);
          });
      },
      // 切换孩子
      chooseStudent: function () {
        this.showChooseStudent = true;
      },
      // 设置孩子
      setStudent: function (event) {
        // 赋值
        this.octopus.passport.campus.parent.studentID = event;

        // 重新加载学生数据
        this.loadStudent();

        // 关闭遮罩
        this.showChooseStudent = false;

      },
      showStudentInfoPanel(num) {
        if (num) {
          this.minPanel = false;
          setTimeout(() => {
            this.fullPanel = true;
          }, 400)

        } else {
          this.fullPanel = false;
          setTimeout(() => {
            this.minPanel = true;
          }, 800)
        }
      },
    },
    props: ["oData"]
  }
</script>



// WEBPACK FOOTER //
// src/components/APP/Campus/Home/ParentHome.vue